import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useSuspenseQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { RoleDetailPage, RoleQueries, type RoleDetailTab } from '@portal/app-admin'

export const Route = createFileRoute('/_auth/preferences/roles/$roleId')({
  component: RoleDetailLayout,
  validateSearch: z.object({
    tab: z.enum(['access', 'users']).default('access'),
  }),
  loader: ({ context: { queryClient }, params: { roleId } }) =>
    queryClient.ensureQueryData(RoleQueries.detail(Number(roleId))),
})

function RoleDetailLayout() {
  const { roleId } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = useNavigate()
  const { data: role } = useSuspenseQuery(RoleQueries.detail(Number(roleId)))

  return (
    <RoleDetailPage
      role={role}
      tab={tab}
      onTabChange={(next: RoleDetailTab) =>
        void navigate({ to: '.', search: { tab: next }, replace: true })
      }
    >
      <Outlet />
    </RoleDetailPage>
  )
}
